import store from '../vuex/index.js';
export default (to, from, next) => {
	//Páginas publicas
	let public_pages = ['/login', '/contract-activation'];

	//Funções de apoio
	let is_public = () => {
		let resp = false;
		public_pages.forEach((item) => {
			if (item == to.path) resp = true;
		});
		return resp;
	};
	let is_logged = () => {
		if (store.state.user_data == null) return false;
		else return true;
	};

	// console.log(to.path, is_logged(), is_public())
	if (is_logged() && (to.path == '/login' || to.path == '/'))
		next('/dashboard');
	else if (to.path != '/login' && is_logged()) next();
	else if (!is_public() && !is_logged()) next('/login');
	else if (is_public() && to.path != '/login') next();
	else next();
};



// WEBPACK FOOTER //
// ./src/router/beforeEach.js